import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as Sentry from '@sentry/angular';
import { getClient } from '@sentry/angular';

bootstrapApplication(App, appConfig)
  .then(() => {
    const loader = document.getElementById('global-loader');
    if (loader) {
      loader.style.opacity = '0';
      loader.style.visibility = 'hidden';
      setTimeout(() => loader.remove(), 300);
    }
  })
  .catch((err) => {
    console.error('Failed to bootstrap application:', err);
    if (getClient()) {
      Sentry.captureException(err, {
        tags: { component: 'Bootstrap' },
        extra: { bootstrapError: true },
      });
    }
  });
